import { STORE_TOOLTIP_DATA, DELETE_TOOLTIP_DATA } from './Tooltip.types';
import { IStoreTooltipDataActionPayload, IRemoveTooltipDataActionPayload } from './Tooltip.interface';

export const storeTooltipData = (payload: IStoreTooltipDataActionPayload) => ({
  type: STORE_TOOLTIP_DATA,
  payload,
});

export const deleteTooltipData = (payload: IRemoveTooltipDataActionPayload) => ({
  type: DELETE_TOOLTIP_DATA,
  payload,
});
